var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row dashboard"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('b-card', {
    staticStyle: {
      "border": "1px solid #cecece"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 dashboard-style"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Client :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>",
      "right": _vm.srLoader
    }
  }, [_c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.clientList,
      "selected-option": _vm.clientItemObj,
      "name": "client",
      "placeholder": "Select client"
    },
    on: {
      "select": _vm.getclients
    },
    nativeOn: {
      "click": function($event) {
        return _vm.loadClientListOnce.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.client),
      callback: function($$v) {
        _vm.client = $$v
      },
      expression: "client"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('client')),
      expression: "errors.has('client')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('client')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Delivery User :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>",
      "right": _vm.srLoader
    }
  }, [_c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.srList,
      "selected-option": _vm.srItemObj,
      "name": "SR",
      "placeholder": "Select SR"
    },
    on: {
      "select": _vm.getSRs
    },
    model: {
      value: (_vm.srId),
      callback: function($$v) {
        _vm.srId = $$v
      },
      expression: "srId"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('SR')),
      expression: "errors.has('SR')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('SR')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "topSrListParent"
  }, [_c('b-card', [_c('div', {
    staticClass: "Delivery"
  }, [_c('legend', [_c('span', {
    staticStyle: {}
  }, [_vm._v(" " + _vm._s(_vm.getstatusName) + " - " + _vm._s(_vm.TotalCount) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "topSrList-table"
  }, [_c('div', {
    staticClass: "row DeliveryStatus"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticClass: "status-button mb-2"
  }, [_c('a', {
    staticClass: "delivey-btn",
    class: {
      'active': _vm.getstatusName == 'DELIVERY'
    },
    attrs: {
      "href": "#",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.GetDashboardDetails('DELIVERY')
      }
    }
  }, [_vm._v("DELIVERY")]), _vm._v(" "), _c('a', {
    staticClass: "delivey-btn",
    class: {
      'active': _vm.getstatusName == 'RVP'
    },
    attrs: {
      "href": "#",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.GetDashboardDetails('RVP')
      }
    }
  }, [_vm._v("RVP")]), _vm._v(" "), _c('a', {
    staticClass: "delivey-btn",
    class: {
      'active': _vm.getstatusName == 'RTO'
    },
    attrs: {
      "href": "#",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.GetDashboardDetails('RTO')
      }
    }
  }, [_vm._v("RTO")]), _vm._v(" "), _c('a', {
    staticClass: "delivey-btn",
    class: {
      'active': _vm.getstatusName == 'DTO'
    },
    attrs: {
      "href": "#",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.GetDashboardDetails('DTO')
      }
    }
  }, [_vm._v("DTO")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-3 col-sm-6 py-2"
  }, [_c('div', {
    staticClass: "card bg-success text-white h-100"
  }, [_c('div', {
    staticClass: "card-body bg-primary"
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('i', {
    staticClass: "fa fa-edit fa-4x"
  })]), _vm._v(" "), _c('h6', {
    staticClass: "text-uppercase",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Allocate to SR")]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v(_vm._s(_vm.SRallocatedCount))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-3 col-sm-6 py-2"
  }, [_c('div', {
    staticClass: "card bg-success text-white h-100"
  }, [_c('div', {
    staticClass: "card-body bg-warning"
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('i', {
    staticClass: "fa fa-motorcycle fa-4x"
  })]), _vm._v(" "), _c('h6', {
    staticClass: "text-uppercase",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("OFD")]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v(_vm._s(_vm.OfdCount))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-3 col-sm-6 py-2"
  }, [_c('div', {
    staticClass: "card bg-success text-white h-100"
  }, [_c('div', {
    staticClass: "card-body bg-success"
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('i', {
    staticClass: "fa fa-dropbox fa-4x"
  })]), _vm._v(" "), _c('h6', {
    staticClass: "text-uppercase",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.thirdOptionForShipmentType))]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v(_vm._s(_vm.deliveryCount))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-3 col-sm-6 py-2"
  }, [_c('div', {
    staticClass: "card bg-success text-white h-100"
  }, [_c('div', {
    staticClass: "card-body bg-danger"
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('i', {
    staticClass: "fa fa-times-circle fa-4x"
  })]), _vm._v(" "), _c('h6', {
    staticClass: "text-uppercase",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("NDR")]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v(_vm._s(_vm.NdrCount))])])])])])])])])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 topSrListParent"
  }, [_c('b-card', [_c('div', {
    staticClass: "topSrList"
  }, [_c('legend', [_vm._v("Top Five Performer ")]), _vm._v(" "), _c('div', {
    staticClass: "DeliveryStatus"
  }, [_c('span', {
    staticClass: "getTopSR mb-2 mt-2"
  }, [_c('a', {
    staticClass: "delivey-btn",
    class: {
      'active': _vm.getday == 'day'
    },
    attrs: {
      "href": "#",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.GetTopSRList('day')
      }
    }
  }, [_vm._v("Day")]), _vm._v(" "), _c('a', {
    staticClass: "delivey-btn",
    class: {
      'active': _vm.getday == 'weekly'
    },
    attrs: {
      "href": "#",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.GetTopSRList('weekly')
      }
    }
  }, [_vm._v("Weekly")]), _vm._v(" "), _c('a', {
    staticClass: "delivey-btn",
    class: {
      'active': _vm.getday == 'month'
    },
    attrs: {
      "href": "#",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.GetTopSRList('month')
      }
    }
  }, [_vm._v("Month")])])]), _vm._v(" "), _c('div', {
    staticClass: "topSrList-table"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Delivery User Name")]), _vm._v(" "), _c('th', [_vm._v("Count")])]), _vm._v(" "), _c('tbody', [(_vm.IsTopSRs == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.TopSRs), function(val, i) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(i + 1))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.DeliveryUserName) + " -")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.shipments))])])
  })], 2)])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('legend', [_vm._v("Fake Details ")]), _vm._v(" "), _c('b-card', {
    staticClass: "ml-0",
    staticStyle: {
      "border": "1px solid #cecece"
    }
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-primary px-4",
    attrs: {
      "type": "button",
      "id": "btn"
    },
    on: {
      "click": _vm.fakeDetails
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.hasFetched ? "Fake Details" : "Fake Details") + "\n                ")]), _vm._v(" "), (_vm.showTable) ? _c('button', {
    staticClass: "btn btn-light btn-sm fw-bold mt-2 ml-2",
    staticStyle: {
      "width": "32px",
      "height": "32px",
      "padding": "0"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.isRefreshDisabled
    },
    on: {
      "click": _vm.refreshData
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]) : _vm._e()]), _vm._v(" "), (_vm.showTable) ? _c('div', [_c('table', {
    staticClass: "table table-bordered mt-2 tablebg fontdiv"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v("Hub Level")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v("Fake Marked")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v("Delivered")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v("Undelivered")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v("Pending in SR bucket")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td'), _vm._v(" "), _c('td', {
    staticClass: "text-primary fw-bold text-decoration-underline cursor-pointer",
    on: {
      "click": _vm.showHubShipments
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.hubSummary.FakeMarked) + "\n                      ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.hubSummary.Delivered))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.hubSummary.Undelivered))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.hubSummary.PendinginSR))])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered tablebg fontdiv"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v("SR Level")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v("Fake Marked")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v("Delivered")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v("Undelivered")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v("Pending in SR bucket")])])])]), _vm._v(" "), _c('tbody', [(_vm.srlevelcount.length === 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.srlevelcount), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(data.SRname))]), _vm._v(" "), _c('td', {
      staticClass: "text-primary fw-bold text-decoration-underline cursor-pointer",
      on: {
        "click": function($event) {
          return _vm.showSrDetails(data.Facilitycount, data.SRname)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(data.FakeMarked) + "\n                      ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Delivered))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Undelivered))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.PendinginSR))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "modal-set",
    class: {
      show: _vm.showSrShipmentModal
    },
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-primary text-white d-flex justify-content-between align-items-center"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Shipment Details for: " + _vm._s(_vm.selectedSr))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-light btn-sm fw-bold",
    staticStyle: {
      "width": "32px",
      "height": "32px",
      "padding": "0",
      "border-radius": "4px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeSrModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticClass: "table table-bordered tablebg fontdiv"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Fake Reason")])])]), _vm._v(" "), _c('tbody', [(_vm.srShipmentData.delivered) ? _vm._l((_vm.srShipmentData.delivered), function(shipment, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(shipment.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(" Delivered")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipment.fakestatereasontitle))])])
  }) : _vm._e(), _vm._v(" "), (_vm.srShipmentData.undelivered) ? [_vm._l((_vm.srShipmentData.undelivered), function(ship, i) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(ship.ShippingID))]), _vm._v(" "), _c('td', [_vm._v("Undelivered")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ship.fakestatereasontitle))])])
  }), _vm._v(" "), (_vm.srShipmentData.undelivered.length === 0) ? _c('tr') : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.srShipmentData.pending) ? [_vm._l((_vm.srShipmentData.pending), function(ship, i) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(ship.ShippingID))]), _vm._v(" "), _c('td', [_vm._v("Pending in SR bucket")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ship.fakestatereasontitle))])])
  }), _vm._v(" "), (_vm.srShipmentData.pending.length === 0) ? _c('tr') : _vm._e()] : _vm._e()], 2)])])])])])]) : _vm._e()])], 1)])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b029f074","hasScoped":false}!./src/views/components/dashboard/dashboard.component.html
// module id = 825
// module chunks = 1